import { useCallback } from 'react';
import { hideAppSpinner, showAppMessage, showAppSpinner } from '@rainbow-modules/app';
import useHttpMutation from 'data/firestore/useHttpMutation';
import { BaseFormProps } from './types';
import FormFooter from './footer';
import Form from './form';
import { Container, Content } from './styled';

interface CreateFormProps extends BaseFormProps {}

const CreateForm = ({
    agentId = '',
    onRequestClose = () => {},
    onCompleted = () => {},
}: CreateFormProps) => {
    const {
        mutateAsync: createWorkplace,
    } = useHttpMutation<Record<string, unknown>, Record<string, unknown>>({
        pathname: `/agents/${agentId}/workplaces`,
        method: 'POST',
        onSuccess: (response) => {
            onRequestClose();
            onCompleted(response);
        },
    });

    const handleSubmit = useCallback(
        async (values: Record<string, unknown>) => {
            try {
                showAppSpinner();
                await createWorkplace({
                    body: values,
                });
            } catch (error) {
                showAppMessage({
                    variant: 'error',
                    message: (error as Error).message,
                    timeout: 5000,
                });
            }
            hideAppSpinner();
        },
        [createWorkplace],
    );

    return (
        <Container>
            <Content>
                <Form
                    agentId={agentId}
                    id="workplace-form"
                    onSubmit={handleSubmit}
                />
            </Content>
            <FormFooter
                formId="workplace-form"
                onCancelClick={onRequestClose}
            />
        </Container>
    );
};

export default CreateForm;
